<template>
  <div class="bgf4">
    <div class="bzxq"><!--动态详情-->
      <span class="blueBlock"></span>
      {{data.title}}
    </div>
    <div class="box bgfff" style="display:block;">
      <!--<div class="title">{{data.title}}</div>-->
      <div class="date-read">
        <a-icon type="calendar" />：{{data.publishdate}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a-icon type="eye" />：{{data.readnum}}
      </div>
      <div style="background: white;margin-left: -20px;padding-left: 20px;">
        <div class="imgdiv" v-if="data.coverimage!=null">
          <img :src="image+this.data.coverimage" class="img">
        </div>
        <div :class="[data.coverimage==null?'content1':'content']" v-html="desc" ></div>
      </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'

export default {
  name: 'App',
  data(){
    return{
      data:[],
      desc:'',
      image:''
    }
  },
  computed:{

  },
  created(){
    this.queryByID(this.$route.query.id)
    this.image = http.imageURL
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    queryByID(id){
      http.get('/queryByIdScdt',{params:{id:id}}
      ).then((res) => {
          this.data = res.data.result
          this.desc = this.data.content
          this.data.readnum = parseInt(this.data.readnum)
          // this.data.coverimage = 'http://localhost:8080/jeecg-boot/sys/common/static/'+this.data.coverimage
      })
    },
  },
}
</script>


<style scoped>
  @import "../../config/AquaticStateDetial.css"
</style>







// WEBPACK FOOTER //
// src/views/aquaticstate/AquaticStateDetial.vue